'use client';

import styled from 'styled-components';

export const StyledYearContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 8px;
  padding-bottom: 0;
`;

export const StyledYearHeading = styled.h2`
  text-align: center;
  margin: 20px 0;
`;

export const StyledLegendGrid = styled.section`
  width: 100%;
  max-width: 1200px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(226px, 1fr));
  gap: 12px;
  justify-items: center;
  margin-bottom: 0;
  padding-bottom: 0;
`;

export const StyledSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--size-2h);
  width: 100%;
`;
